// monthNavigationContext.tsx
import React, { createContext, useContext, useState } from 'react';

interface MonthSelections {
    [tableName: string]: string; // format { schedule_table: "2024-11" }
}

interface MonthNavigationContextType {
    monthSelections: MonthSelections;
    setMonthSelection: (tableName: string, monthYear: string) => void;
    getMonthSelection: (tableName: string) => string | undefined;
}

const MonthNavigationContext = createContext<MonthNavigationContextType | undefined>(undefined);

export const MonthNavigationProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
    const [monthSelections, setMonthSelections] = useState<MonthSelections>({});

    const setMonthSelection = (tableName: string, monthYear: string) => {
        setMonthSelections(prev => ({
            ...prev,
            [tableName]: monthYear
        }));
    };

    const getMonthSelection = (tableName: string) => {
        return monthSelections[tableName];
    };

    return (
        <MonthNavigationContext.Provider value={{ monthSelections, setMonthSelection, getMonthSelection }}>
            {children}
        </MonthNavigationContext.Provider>
    );
};

export const useMonthNavigation = () => {
    const context = useContext(MonthNavigationContext);
    if (!context) throw new Error('useMonthNavigation must be used within MonthNavigationProvider');
    return context;
};